import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ZkNotificationService } from '@zenklub/ng-ui';
import { ZkIOption } from '@zenklub/ng-ui/component/input/dropdown/dropdown.interface';
import {
	IProfessionalFinancial,
	IProfessionalPerson,
} from 'app/interfaces/professionalprofile.interface';
import { ErrorService } from 'app/services/error.service';

@Component({
	selector: 'app-billing-data',
	templateUrl: './billing-data.component.html',
	styleUrls: ['./billing-data.component.scss'],
})
export class BillingDataComponent implements OnInit {
	@Input() formParams: FormGroup;
	@Input() showTitle = true;
	@Input() professionalPerson: IProfessionalPerson;
	@Output() triggerValidation = new EventEmitter<string>();
	@Output() waitingIdwallResponse = new EventEmitter<boolean>();
	@Output() cpnjValidationTrigger = new EventEmitter<any>();

	serviceCodeOptions: ZkIOption[];
	onValidationSuccess: boolean;
	validationRequired: boolean;
	isValidationTakingWhile = false;
	responseValidation: IProfessionalFinancial;
	idwallDebounce: NodeJS.Timeout;
	professionalFinancial: IProfessionalFinancial[];
	isChanging = true;
	canValidadeFields = true;
	isCNAEError = false;

	idWallError: string;

	constructor(
		protected notifications: ZkNotificationService,
		protected translateService: TranslateService,
		protected errorService: ErrorService
	) {}

	ngOnInit(): void {
		this.setServiceCodeOptions();
	}

	public isIdwallCalled(idwallWait: any): void {
		this.waitingIdwallResponse.emit(idwallWait);
	}

	isFieldInvalid(formGroup: FormGroup, fieldName: string): boolean {
		const field = formGroup.get(fieldName);
		if (field) {
			return field.invalid && field.dirty;
		}
		return false;
	}

	showErrorMessages(formParams: FormGroup): boolean {
		if (!this.canValidadeFields) {
			return true;
		}
		if (!this.isFieldInvalid(formParams, 'businessFiscalId')) {
			return true;
		}
	}
	private setServiceCodeOptions() {
		this.serviceCodeOptions = [
			{
				value: '8650-0/03 - 4.16 Psicologia',
				label: '4.16 | Psicologia',
			},
			{
				value: '8650-0/03 - 4.15 Psicanalise',
				label: '4.15 | Psicanalise',
			},
			{
				value: '8650-0/05 - 4.09 Terapia Convencional',
				label: '4.09 | Terapia Convencional',
			},
			{
				value: '8690-9/01 - 4.09 Terapia Não Convencional (Holística)',
				label: '4.09 | Terapia Não Convencional (Holística)',
			},
			{
				value: '8599-6/04 - 8.02 Treinamento (coaching)',
				label: '8.02 | Treinamento (coaching)',
			},
		];
	}

	public listenFormChanges(): void {
		this.formParams?.controls?.businessFiscalId?.valueChanges.subscribe(() => {
			this.onValidationSuccess = false;
		});
	}

	setErrorMessage(message: string) {
		if (!message) {
			message = this.translateService.instant('ERRORS.NOTSPECIFIED');
		}
	}
}
